import { render, staticRenderFns } from "./cjActModal.vue?vue&type=template&id=677c8440&scoped=true"
import script from "./cjActModal.vue?vue&type=script&lang=js"
export * from "./cjActModal.vue?vue&type=script&lang=js"
import style0 from "./cjActModal.vue?vue&type=style&index=0&id=677c8440&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677c8440",
  null
  
)

export default component.exports